const footerTextLinks = () => {
  const footerTextBlock = document.querySelector('.footer-block__details-text');
  if (!footerTextBlock) return;
  const allLinks = footerTextBlock.querySelectorAll('a');
  allLinks.forEach((link) => {
    link.classList.add('underline-links-hover', 'underline-links-hover--pink');
    const linkText = link.textContent;
    link.innerHTML = `<span>${linkText}</span>`;
  });
};

export const footer = () => {
  footerTextLinks();
};
